import { Icon } from '@iconify/react';
import { isGitlabAvailable } from '@immobiliarelabs/backstage-plugin-gitlab';
import gitlabPlugin from '@immobiliarelabs/backstage-plugin-gitlab/alpha';
import {
  isComponentEntity,
  isDataProductEntity,
  isSolutionModuleEntity,
} from '@ipen-portal/ipen-entity-model';
import { and, not, showMonitoring } from '@ipen-portal/plugin-common';

const showGitlabIntegration = and(
  isGitlabAvailable,
  showMonitoring,
  isComponentEntity,
  not(isDataProductEntity),
  not(isSolutionModuleEntity),
);

const gitlabEntityCardExtensionIds = [
  'entity-card:gitlab/coverage',
  'entity-card:gitlab/issues-table',
  'entity-card:gitlab/languages',
  'entity-card:gitlab/merge-requests-stats',
  'entity-card:gitlab/merge-requests-table',
  'entity-card:gitlab/people',
  'entity-card:gitlab/pipelines-table',
  'entity-card:gitlab/readme',
  'entity-card:gitlab/releases',
] as const;

export const GitlabPlugin: typeof gitlabPlugin = gitlabPlugin.withOverrides({
  extensions: [
    gitlabPlugin.getExtension('entity-content:gitlab/gitlab').override({
      params: {
        filter: showGitlabIntegration,
        // TODO this will work once https://github.com/backstage/backstage/pull/31117 is released and used by the gitlab plugin
        icon: <Icon icon="ant-design:gitlab-filled" />,
      },
    }),
    ...gitlabEntityCardExtensionIds.map(extensionId =>
      gitlabPlugin.getExtension(extensionId).override({
        params: {
          filter: showGitlabIntegration,
        },
      }),
    ),
  ],
});
